import { Component, OnInit } from '@angular/core';
import { TutorialEntryFeatured, TutorialService } from '@ebeihilfe/core';

@Component({
  selector: 'portal-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
  standalone: false,
})
export class TutorialComponent implements OnInit {
  public tutorials: TutorialEntryFeatured[];

  constructor(public tutorialService: TutorialService) {}

  public ngOnInit(): void {
    this.tutorials = this.tutorialService.getTutorials();
  }
}
